import { ref, shallowRef } from "vue";
import { defineStore } from "pinia";
import { useRoute } from "vue-router";

import { setAuthState } from "../composables/auth";
import { user } from "../api/auth";

import { FEATURE_EXCEED_MESSAGE_MAP, ROUTE_NAME_TO_FEATURE_MAP } from "../utils/subscription";
import { useSubscriptionTrackerStore } from "./subscription-tracker.store";

export const useFeatureUsageStore = defineStore("feature-usage", () => {
    const { getUser, setUser } = setAuthState();

    const userFeatureUsage = ref(getUser()?.feature_usage ?? []);
    const singleFeatureUsage = shallowRef();
    const activeRoute = shallowRef('');
    const showLimitExceed = shallowRef(false);
    const currentFeatureExceedMessage = shallowRef('');
    const currentFeature = shallowRef(null);
    const route = useRoute();
    const subscriptionTrackerStore = useSubscriptionTrackerStore()
    const hideLimitExceed = () => {
        showLimitExceed.value = false;
    }

    const setShowLimitExceed = (forFeature = null) => {
        if(forFeature != null) {
            currentFeature.value = forFeature;
            currentFeatureExceedMessage.value = FEATURE_EXCEED_MESSAGE_MAP[forFeature];
        }else {
            currentFeature.value = ROUTE_NAME_TO_FEATURE_MAP[route.name]
            currentFeatureExceedMessage.value = FEATURE_EXCEED_MESSAGE_MAP[currentFeature.value];
        }

        showLimitExceed.value = true;
        
        subscriptionTrackerStore.trackModal(currentFeature.value)
    }
    
    const fetchFeatureUsage = feature_name => {
        const feature = userFeatureUsage.value.find(el => el.name == feature_name)
        
        if (feature == null) {
            return userFeatureUsage.value.find(el => el.name == 'resume_upload')
        }
        
        return feature
    }

    const setFeatureUsage = (features) => {
        userFeatureUsage.value = features
    }
    
    const setActiveRouteFeature = (route) => {
        activeRoute.value = route;
    };

    const setSingleFeatureUsage = (feature) => {
        singleFeatureUsage.value = feature;
    }

    const refresh = async() => {
        const result = await user();

        if (result?.data?.data) {
            setUser(result.data?.data);
            setFeatureUsage(result.data?.data?.feature_usage);
            singleFeatureUsage.value = fetchFeatureUsage(activeRoute.value);
        }
    }
    
    return {
        singleFeatureUsage,
        userFeatureUsage,
        activeRoute,
        showLimitExceed,
        currentFeature,

        currentFeatureExceedMessage,

        hideLimitExceed,
        setShowLimitExceed,
        refresh,
        fetchFeatureUsage,
        setSingleFeatureUsage,
        setActiveRouteFeature,
        setFeatureUsage
    }
})
